import {
    ExtractFetchParams,
    ExtractQueryOptions,
    ExtractResponse,
    useSuspenseRequest,
} from "@/lib/openapi/hooks";

export type UseMessagesResponse = ExtractResponse<"telegramMessages", "/message", "get">;

export type UseMessagesFetchParams = ExtractFetchParams<"telegramMessages", "/message", "get">;

export const useMessagesSuspenseQuery = <
  Response extends UseMessagesResponse,
  Transformed = Response
>({
  queryOptions,
  fetchParams,
}: {
  queryOptions?: ExtractQueryOptions<Response, Transformed>;
  fetchParams?: UseMessagesFetchParams;
}) =>
  useSuspenseRequest("telegramMessages", "/message", {
    method: "get",
    queryOptions,
    fetchParams,
  });
